import { jsx as _jsx } from "react/jsx-runtime";
import '../../immer-init';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'broadcastchannel-polyfill';
import '../../styles';
import { store } from './json-view-store';
import history from '../../history';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import JsonViewApp from './json-view-component';
import { authenticationChannelReceiverFactory } from '../../core/middleware/authentication-channel-middleware';
import { buildSubscriptions as buildChannelSubscriptions } from '../pop-up/case-channel-subscriptions';
const currentURL = new URL(`${window?.top?.location}`);
const subscriptions = buildChannelSubscriptions(currentURL);
authenticationChannelReceiverFactory(subscriptions, store);
const App = ()=>{
    return /*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: /*#__PURE__*/ _jsx(Router, {
            history: history,
            children: /*#__PURE__*/ _jsx(Switch, {
                children: /*#__PURE__*/ _jsx(Route, {
                    path: "/",
                    component: JsonViewApp
                })
            })
        })
    });
};
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element not found');
}
const root = createRoot(container);
root.render(/*#__PURE__*/ _jsx(App, {}));
